import cookie from 'react-cookie';

const NavigationService = function() {
  const removeLoginRedirectCookies = () => {
    cookie.remove('returnToState');
    cookie.remove('returnToStateParams');
  };

  const saveLoginRedirect = () => {
    // if ($rootScope.toState && $rootScope.toState.name !== 'login') {
    //   cookie.put('returnToState', JSON.stringify($rootScope.toState));
    //   cookie.put('returnToStateParams', JSON.stringify($rootScope.toStateParams));
    // }
  };

  return {
    removeLoginRedirectCookies,
    saveLoginRedirect,
  };
};

export default new NavigationService();
